import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import axios from "axios";
import { baseUrl } from "../../../Config/baseUrl";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { getSliderFn } from "../../../Services/Slider";

export default function AddMenu({ getMenu, initialData, setInitailData }) {


    const [open, setOpen] = useState(false)

    const [data1, setData1] = useState([])

    const { data: getSliderResponse, refetch } = useQuery({
        queryKey: "get-slider",
        queryFn: getSliderFn
    });


    const AddPageName = (req) => {
        axios
            .post(`${baseUrl}/blog/main-menu-api/`, req, {
                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,
                    "Access-Control-Allow-Origin": "*",
                },
            })
            .then((res) => {
                if (res?.data?.response_code === 200) {

                    toast.success(res?.data?.message)
                    getMenu()
                    handleClose()
                }

                else {
                    toast.warn(res?.data?.message)

                }
            })
            .catch((err) => {
                toast.error("Error deleting blog", err?.response?.data?.message);
            });
    };

    const UpdatePageName = (req) => {
        axios
            .patch(`${baseUrl}/blog/main-menu-api/`, req, {
                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,
                    "Access-Control-Allow-Origin": "*",
                },
            })
            .then((res) => {
                if (res?.data?.response_code === 200) {

                    toast.success(res?.data?.message)
                    getMenu()
                    handleClose()

                }

                else {
                    toast.warn(res?.data?.message)

                }
            })
            .catch((err) => {
                toast.error("Error deleting blog", err?.response?.data?.message);
            });
    };
    const formik = useFormik({
        initialValues: {
            name: initialData?.name || "",
            image: null,
            slider: initialData?.slider || "",
            page_id: initialData?.page_id || ""
        },

        enableReinitialize: true,
        onSubmit: (values) => {


            const fb = new FormData()
            fb.append("name", values?.name)
            fb.append("page_id", values?.page_id)
            if (values?.slider) fb.append("slider", values?.slider)
            if (values?.image) fb.append("image", values?.image)
            if (initialData !== null) fb.append("menu_id", initialData?.id)

            if (initialData !== null) {

                UpdatePageName(fb)
            }

            else {
                AddPageName(fb)

            }



        },
    });

    function handleClose() {

        setInitailData(null)

        setOpen(false)

        formik.handleReset()


    }
    const getCreer = () => {
        axios
            .get(`${baseUrl}/blog/frontend-page-id-api/`, {
                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,
                    "Access-Control-Allow-Origin": "*",
                },
            })
            .then((res) => {
                setData1(res.data?.data);
            })
            .catch((err) => {
                toast.error("Error deleting blog", err?.response?.data?.message);
            });
    };

    useEffect(() => {
        getCreer()
    }, [])



    return (
        <>




            <Button variant="outlined" onClick={() => setOpen(true)} startIcon={<Add />} >Add</Button>






            {(open || Boolean(initialData)) && <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
                <div className="bg-white w-full max-w-md rounded-2xl shadow-lg p-6">
                    <h2 className="text-xl font-semibold mb-4">{Boolean(initialData) ? "Update" : "Add"} Details</h2>

                    <form onSubmit={formik.handleSubmit} className="space-y-4">

                        {/* Name Field */}
                        <div>
                            <label className="block mb-1 font-medium">Name</label>
                            <input
                                type="text"
                                name="name"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300 outline-none"
                                required
                            />
                        </div>

                        {/* Image Field */}
                        <div>
                            <label className="block mb-1 font-medium">Image</label>
                            <input
                                type="file"
                                name="image"
                                accept="image/*"
                                onChange={(e) => formik.setFieldValue("image", e.target.files[0])}
                                className="w-full border rounded-lg px-3 py-2 bg-white"

                            />
                        </div>

                        <div>
                            <label className="block mb-1 font-medium">Slider</label>

                            <select name="slider" value={formik.values.slider}
                                onChange={formik.handleChange} className="w-full border rounded-lg px-3 py-2 bg-white">

                                <option disabled value={""} >Select Slider</option>
                                {getSliderResponse?.data?.data?.map((i) => (



                                    <option value={i?.id}>{i?.title}</option>
                                ))}

                            </select>

                        </div>


                        <div>
                            <label className="block mb-1 font-medium">Page</label>

                            <select name="page_id" value={formik.values.page_id}
                                onChange={formik.handleChange} className="w-full border rounded-lg px-3 py-2 bg-white">

                                <option value={""} >Select Page</option>
                                {data1?.map((i) => (



                                    <option value={i?.id}>{i?.name}</option>
                                ))}

                            </select>

                        </div>


                        {/* Buttons */}
                        <div className="flex justify-end gap-3 pt-3">
                            <button
                                type="button"
                                onClick={handleClose}
                                className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                            >
                                Save
                            </button>
                        </div>

                    </form>
                </div>
            </div>}

        </>
    );
}
